/**
 * 「本文を開いてから同意」（課題 #77 / BE PR #130。2026-09-29 高尾さん決定）の判定。
 *
 * BE は、同意（POST /v1/consent、招待の受け入れ）の前に、その文書の今の版の本文を
 * 本文を開く API で取得した記録（サーバーの時刻）を求める。無ければ 409 DOCUMENT_NOT_OPENED。
 * 画面では、本文を開くまで「同意する」を押せないようにし、同意には開いた版を送る。
 *
 * BE の反映と FE の反映の順番を問わないよう、本文を開く API が無い古い BE（404）では、
 * 一覧で受け取っている本文を使ってこれまでどおり同意できるようにする。
 */
import { RequestError } from '../api/client';

/** 開いた本文 */
export interface OpenedDocument {
  version: string;
  content: string;
  /** 古い BE のため、一覧の本文で代用した（開いた記録はサーバーに残っていない） */
  legacy: boolean;
}

/**
 * 本文を開く API が無い古い BE か。ルートが無いときは FastAPI 既定の `{"detail":"Not Found"}` で、
 * エラーコードが付かない。BE が「文書が見つからない」と返すとき（`HTTP_404` 等のコード付き）は
 * 古い BE と取り違えない（一覧の本文で同意させると、同意が 409 で断られるだけになる）。
 */
export function isOpenApiMissing(err: unknown): boolean {
  return err instanceof RequestError && (err.status === 404 || err.status === 405) && !err.errorCode;
}

/** 本文を開いた記録が無いため、同意できなかったか */
export function isDocumentNotOpened(err: unknown): boolean {
  return err instanceof RequestError && err.status === 409 && err.errorCode === 'DOCUMENT_NOT_OPENED';
}

/** 同意に送る版。開いた本文の版を優先する（一覧を読んだ後に改訂されていても、開いた版で同意する） */
export function versionForGrant(listedVersion: string, opened: OpenedDocument | undefined): string {
  return opened?.version || listedVersion;
}
